import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import Smiley from '../../Smiley';
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus, getChatIcons } from '../../redux/FeedbackRedux';
import { selectedFirst } from '../../jquery/scrollcontrol.js';
import ReactDOMServer from 'react-dom/server';
import Linkify from 'linkify-react';

class MessengerChat extends React.Component {
	constructor(props) {
		super(props);
		// This binding is necessary to make `this` work in the callback
		this.handleClick = this.handleClick.bind(this);
		this.handleDetailClick = this.handleDetailClick.bind(this);
	}

	handleChatClick(event) {
		event.preventDefault();
		window.scrollTo(0, document.body.scrollHeight);
		document.getElementById('chat-textarea').focus();
		document.getElementById('chat-textarea').select();
	}

	handleClick(event) {
		event.preventDefault();
		var payload = this.props.feedback;
		this.props.dispatch(setSelectedFeedback(payload.id));
		this.props.dispatch(ajaxFeedback(payload.id));
	}

	handleDetailClick(event) {
		event.preventDefault();
		console.log('show');
		var payload = this.props.feedback;
		this.props.dispatch(setSelectedFeedback(payload.id));
		this.props.dispatch(ajaxFeedback(payload.id));
	}

	getBadgeType(status) {
		let badgetype = "badge-primary";
		switch (status) {
			case window.feedbackStatus.Resolved.value:
				badgetype = "badge-success";
				break;
			case window.feedbackStatus.Open.value:
				badgetype = "badge-primary"
				break;
		}
		return badgetype;
	}

	render() {

		let badgetype = this.getBadgeType(this.props.feedback.status);

		let priorityClass = "priority-" + (this.props.feedback.status === window.feedbackStatus.Resolved.value ? 3 : 10);

		let iconList = getChatIcons(this.props.feedback, "ml-auto mr-3");

		return (
			<div className="col-sm-12" onClick={this.handleClick}>
				<div className={"feedback-card-v2 border mb-2 d-flex align-items-center cursor-pointer " + priorityClass}>
					{/* <input type="checkbox" className="feedback-card-v2-checkbox mr-2" onChange={this.updateChecked.bind(this)} checked={this.props.state.checked_feedbacks.includes(feedback.id)} /> */}
					<span className="feedback-card-v2-name">{this.props.feedback.name}</span>
					<div className="feedback-card-v2-badge">
						<span className={"badge badge-pill " + badgetype}>{window.feedbackStatus[this.props.feedback.status].label}</span>
					</div>
					<span className="text-primary feedback-card-v2-description">
						<b>
							{(this.props.feedback.description.length > 120 ? this.props.feedback.description.substring(0, 120) + "..." : this.props.feedback.description)}</b>
					</span>
					{iconList}
					<span className="feedback-card-v2-date">{this.props.feedback.created_at}</span>
				</div>

			</div>

		);
	}
}

function mapStateToProps(state) {
	return { state: state, red_alerts_list: state.red_alerts_list ?? null }
}

export default connect(mapStateToProps)(MessengerChat)
